import { useQuery } from "@tanstack/react-query";
import omit from "lodash/omit";
import { fetchShortlists, ShortlistCollection } from "PFCore/services/shortlist";
import { HighlightsParam } from "PFCore/types/highlights_param";
import { QueryOptions, QueryParams } from "PFTypes";

import { shortlistsKeys } from "./query_keys";

export type ActivityShortlistsParams = QueryParams & HighlightsParam & { source?: string };

export const useActivityShortlists = (
  activityId: number,
  params: ActivityShortlistsParams = {},
  options: QueryOptions<ShortlistCollection> = {}
) =>
  useQuery<ShortlistCollection>({
    queryKey: shortlistsKeys.activityShortlists(activityId, params),
    queryFn: () => fetchShortlists(activityId, omit(params, "source")),
    retry: false,
    staleTime: 0,
    ...options
  });
